module.exports = __webpack_public_path__ + "img/slide9.c1c5dd9c.png";